// Test: V_PRO_MIX_16 | Black Friday Gift-Ladder Bundle System — PDP bundle builder steps
(() => {
  const init = (builder) => {
    const $ = (selector) => builder.querySelector(selector);
    const $$ = (selector) => builder.querySelectorAll(selector);

    const chipSummary = $("[data-c-mix16-chip-summary]");
    const build = $(".c-v-pro-mix-16-build");
    const slots = [...$$("[data-c-mix16-slot]")];
    const modeButtons = $$("[data-c-mix16-mode-btn]");
    const added = $("[data-c-mix16-added]");
    const barFill = $(".c-v-pro-mix-16-build__bar-fill");

    const picker = $("[data-c-mix16-picker]");
    const gallery = $("[data-c-mix16-gallery]");
    const sizesWrap = $("[data-c-mix16-sizes]");
    const swatches = [...$$("[data-c-mix16-swatch]")];
    const addButton = $("[data-c-mix16-add]");

    const giftCards = [...$$("[data-c-mix16-gift]")];
    const giftPicker = $("[data-c-mix16-gift-picker]");
    const giftSizes = $("[data-c-mix16-gift-sizes]");
    const giftAdd = $("[data-c-mix16-gift-add]");
    const guide = $("[data-c-mix16-guide]");

    const state = {
      pairs: [], // one entry per slot: { variantId, productId, color, size, image } or null
      slot: 0, // slot index the picker is filling
      filter: "marathon", // active collection in the picker (Var B can switch)
      swatch: null,
      size: "",
      gifts: [], // chosen sleeves: { productId, variantId, size }
      giftCard: null, // sleeve card the size modal is open for
      giftSize: "",
      pack: null, // chosen pack button — holds price / summary data
    };

    const money = (value) => `$${Number(value).toFixed(2)}`;

    const setText = (selector, value) => {
      $$(selector).forEach((el) => (el.textContent = value));
    };

    // Slots + "x of y pairs added" reflect state.pairs
    const renderSlots = () => {
      const total = state.pairs.length;
      const filled = state.pairs.filter(Boolean).length;
      const nextEmpty = state.pairs.findIndex((pair) => !pair);

      slots.forEach((slot, index) => {
        const pair = state.pairs[index];
        const img = slot.querySelector(".c-v-pro-mix-16-slot__img");
        const label = slot.querySelector("[data-c-mix16-slot-label]");
        const size = slot.querySelector("[data-c-mix16-slot-size]");

        slot.hidden = index >= total;
        slot.classList.toggle("c-v-pro-mix-16-slot--filled", Boolean(pair));
        slot.classList.toggle("c-v-pro-mix-16-slot--active", index === nextEmpty);

        img.hidden = !pair;
        if (pair) img.src = pair.image;
        label.textContent = pair ? pair.color : index === nextEmpty ? "Tap to add" : `Pair ${index + 1}`;
        size.textContent = pair ? pair.size : "";
      });

      added.textContent = filled;
      barFill.style.width = total ? `${(filled / total) * 100}%` : "0";
      builder.dataset.cMix16Complete = String(total > 0 && filled === total);

      // Same pack summary card mirrors the single pair repeated in every slot
      const samePair = state.pairs.find(Boolean);
      if (samePair) {
        $("[data-c-mix16-same-img]").src = samePair.image;
        setText("[data-c-mix16-same-color]", samePair.color);
        setText("[data-c-mix16-same-size]", samePair.size);
      }

      renderGifts();
    };

    // ---------- Gifts ----------
    // 8 pairs = mystery gift + 1 sleeve, 10 pairs = mystery gift + 2 sleeves. Each sleeve once only.
    const renderGifts = () => {
      const max = Math.max(Number(builder.dataset.cMix16Gifts) - 1, 0);
      state.gifts = state.gifts.slice(0, max);

      giftCards.forEach((card) => {
        const gift = state.gifts.find((item) => item.productId === card.dataset.cMix16GiftId);
        card.classList.toggle("c-v-pro-mix-16-gift--added", Boolean(gift));
        card.querySelector("[data-c-mix16-gift-size]").textContent = gift ? `Size: ${gift.size}` : "";
        card.querySelector("[data-c-mix16-gift-cta]").disabled = !gift && state.gifts.length >= max;
      });

      setText("[data-c-mix16-gifts-chosen]", state.gifts.length);
      setText("[data-c-mix16-gifts-max]", max);
    };

    const selectGiftSize = (size) => {
      state.giftSize = size;
      setText("[data-c-mix16-gift-picker-size]", size);
      giftSizes.querySelectorAll("button").forEach((btn) => {
        btn.setAttribute("aria-pressed", String(btn.dataset.size === size));
      });
      giftAdd.disabled = !size;
    };

    const openGiftPicker = (card) => {
      const variants = JSON.parse(card.dataset.cMix16Variants);

      state.giftCard = card;
      setText("[data-c-mix16-gift-name]", card.dataset.cMix16GiftTitle);
      giftSizes.innerHTML = "";
      variants.forEach((variant) => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "c-v-pro-mix-16-picker__size";
        btn.dataset.size = variant.size;
        btn.textContent = variant.size;
        btn.disabled = !variant.available;
        giftSizes.append(btn);
      });
      selectGiftSize(variants.find((variant) => variant.available)?.size || "");

      giftPicker.showModal();
      document.documentElement.classList.add("c-v-pro-mix-16-locked");
    };

    // ---------- Guide: scroll to the next thing the shopper has to do ----------
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    const scrollToEl = (el) => {
      if (!el) return;
      // After a modal closes / sections toggle — let layout settle first
      setTimeout(() => {
        const header = document.querySelector("[data-site-header]");
        const offset = Math.max(header ? header.getBoundingClientRect().bottom : 0, 0) + 12;
        const rect = el.getBoundingClientRect();
        if (rect.top >= offset && rect.bottom <= window.innerHeight) return; // already in view
        // Centre it in the space below the header; if it's taller than that, line its top up under the header
        const space = window.innerHeight - offset;
        const centred = rect.top - offset - (space - rect.height) / 2;
        const delta = rect.height > space ? rect.top - offset : centred;
        window.scrollTo({ top: window.scrollY + delta, behavior: reduceMotion.matches ? "auto" : "smooth" });
      }, 80);
    };

    const nextStep = () => {
      if (builder.dataset.cMix16Step !== "1") return $(".c-v-pro-mix-16-choose");
      if (builder.dataset.cMix16Review === "true") return $(".c-v-pro-mix-16-summary");
      if (builder.dataset.cMix16Complete !== "true") {
        return build.dataset.cMix16Mode === "same"
          ? $(".c-v-pro-mix-16-same-choose")
          : $(".c-v-pro-mix-16-slot--active") || $(".c-v-pro-mix-16-slots");
      }
      // Pairs done, gifts still to pick
      return builder.dataset.cMix16PicksOpen === "true" ? $(".c-v-pro-mix-16-gift-picks") : $(".c-v-pro-mix-16-gifts");
    };

    const goToNextStep = () => scrollToEl(nextStep());

    const addGift = () => {
      const card = state.giftCard;
      const variant = JSON.parse(card.dataset.cMix16Variants).find((item) => item.size === state.giftSize);

      state.gifts.push({ productId: card.dataset.cMix16GiftId, variantId: variant.id, size: state.giftSize });
      renderGifts();
      giftPicker.close();
      checkDone();
      goToNextStep();
    };

    const toggleGift = (card) => {
      const index = state.gifts.findIndex((item) => item.productId === card.dataset.cMix16GiftId);
      if (index === -1) return openGiftPicker(card);

      state.gifts.splice(index, 1);
      renderGifts();
    };

    // ---------- Review ----------
    // Bundle is done when every slot is filled and every free sleeve is picked
    const isDone = () => {
      const maxGifts = Math.max(Number(builder.dataset.cMix16Gifts) - 1, 0);
      return builder.dataset.cMix16Complete === "true" && state.gifts.length === maxGifts;
    };

    const renderSummary = () => {
      const pack = state.pack.dataset;
      const pairs = Number(pack.cMix16Pack);
      const rows = $("[data-c-mix16-summary-rows]");

      setText("[data-c-mix16-recap-mode]", build.dataset.cMix16Mode === "same" ? "Same Pack" : "Custom Build");
      setText("[data-c-mix16-sum-pairs]", `${pairs} ${pairs === 1 ? "pair" : "pairs"}`);
      // Compare-at = what the chosen pairs cost individually (Var B mixes $35 and $24 styles)
      const priced = state.pairs.filter(Boolean);
      const compare = priced.every((pair) => pair.price)
        ? priced.reduce((sum, pair) => sum + pair.price, 0) / 100
        : Number(pack.cMix16Compare);
      // Bundle price never exceeds what the pairs cost individually (1 pair = its own price)
      const price = Math.min(Number(pack.cMix16Price), compare);
      const save = Math.max(compare - price, 0);
      const onlyMarathon = priced.every((pair) => pair.col === "marathon");

      setText("[data-c-mix16-sum-range]", onlyMarathon ? "Marathon" : "Mix & match");
      setText("[data-c-mix16-sum-compare]", money(compare));
      setText("[data-c-mix16-sum-price]", money(price));
      setText("[data-c-mix16-sum-per]", money(price / pairs));
      setText("[data-c-mix16-sum-save]", `${Math.round((save / compare) * 100)}% · ${money(save)}`);
      setText("[data-c-mix16-sum-total]", money(price));
      setText("[data-c-mix16-sum-atc]", `$${Number.isInteger(price) ? price : price.toFixed(2)}`);
      setText("[data-c-mix16-sum-next]", pack.cMix16Next);

      $("[data-c-mix16-sum-save-row]").hidden = save <= 0;
      $("[data-c-mix16-sum-ship-row]").hidden = pack.cMix16Shipping !== "free";
      $("[data-c-mix16-sum-mystery-row]").hidden = pack.cMix16Gifts === "0";
      $("[data-c-mix16-sum-next-row]").hidden = !pack.cMix16Next;

      // One "FREE" row per chosen sleeve
      rows.querySelectorAll("[data-c-mix16-sum-gift]").forEach((row) => row.remove());
      state.gifts.forEach((gift) => {
        const card = giftCards.find((el) => el.dataset.cMix16GiftId === gift.productId);
        const row = document.createElement("div");
        row.className = "c-v-pro-mix-16-summary__row";
        row.dataset.cMix16SumGift = "";
        row.innerHTML = '<dt></dt><dd class="c-v-pro-mix-16-summary__free">Free</dd>';
        row.querySelector("dt").textContent = card.dataset.cMix16GiftLabel;
        rows.append(row);
      });
    };

    const setReview = (on) => {
      if (on) renderSummary();
      builder.dataset.cMix16Review = String(on);
    };

    // Called after anything that can finish the bundle
    const checkDone = () => {
      if (isDone()) setReview(true);
    };

    // ---------- Add bundle to cart ----------
    // Pairs and gifts are tagged so the discount app (and the test cart) can find the bundle lines
    const addBundle = async (button) => {
      const bundleId = Date.now().toString(36);
      const size = String(state.pairs.length);
      const pairsByVariant = new Map();

      state.pairs.forEach((pair) => {
        pairsByVariant.set(pair.variantId, (pairsByVariant.get(pair.variantId) || 0) + 1);
      });

      const items = [...pairsByVariant].map(([id, quantity]) => ({
        id,
        quantity,
        properties: { _c_bundle_id: bundleId, _c_bundle_size: size },
      }));

      state.gifts.forEach((gift) => {
        items.push({ id: gift.variantId, quantity: 1, properties: { _c_bundle_id: bundleId, _c_bundle_gift: "sleeve" } });
      });

      // Mystery gift product is still to be created — its variant id goes on the builder when it exists
      const mysteryId = builder.dataset.cMix16MysteryVariant;
      if (mysteryId && Number(builder.dataset.cMix16Gifts) > 0) {
        items.push({ id: Number(mysteryId), quantity: 1, properties: { _c_bundle_id: bundleId, _c_bundle_gift: "mystery" } });
      }

      button.disabled = true;
      button.classList.add("is-loading");
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items }),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || "Could not add to cart");

        setText("[data-c-mix16-atc-error]", "");
        document.dispatchEvent(new CustomEvent("c-v-pro-mix-16:cart:open"));
      } catch (error) {
        setText("[data-c-mix16-atc-error]", error.message);
      } finally {
        button.disabled = false;
        button.classList.remove("is-loading");
      }
    };

    const setMode = (mode) => {
      build.dataset.cMix16Mode = mode;
      builder.dataset.cMix16Mode = mode;
      modeButtons.forEach((btn) => {
        btn.setAttribute("aria-pressed", String(btn.dataset.cMix16ModeBtn === mode));
      });
    };

    // Step 1: pack chosen — collapse packs, fill ladder, open "Build your pack"
    const selectPack = (pack) => {
      const pairs = Number(pack.dataset.cMix16Pack);

      state.pack = pack;
      builder.dataset.cMix16Step = "1";
      // 1 pair: Custom build / Same pack mean the same thing — hide the choice and use Custom build
      builder.dataset.cMix16PackSize = String(pairs);
      if (pairs === 1) setMode("custom"); // a Same pack pick is kept as the single pair
      builder.dataset.cMix16Level = pack.dataset.cMix16Level;
      builder.dataset.cMix16Gifts = pack.dataset.cMix16Gifts;
      chipSummary.textContent = pack.dataset.cMix16Summary;
      setText("[data-c-mix16-total]", pairs);
      setText("[data-c-mix16-gift-count]", pack.dataset.cMix16Gifts);
      setText("[data-c-mix16-gift-ordinal]", pack.dataset.cMix16Ordinal || "");
      setText("[data-c-mix16-gift-ordinal-plural]", pack.dataset.cMix16OrdinalNoun || "");

      // Keep pairs already added: trim when the pack shrinks, add empty slots when it grows.
      // In "Same pack" every slot holds the same pair, so new slots get it too.
      const previous = state.pairs;
      const samePair = build.dataset.cMix16Mode === "same" ? previous.find(Boolean) : null;
      state.pairs = Array.from({ length: pairs }, (_, index) => previous[index] || (samePair ? { ...samePair } : null));
      renderSlots();
      checkDone();
      goToNextStep();
    };

    // Back to step 0: show packs again. Pairs and mode are kept for when a new pack is picked.
    const changePack = () => {
      setReview(false);
      builder.dataset.cMix16Step = "0";
      builder.dataset.cMix16Level = "0";
      builder.dataset.cMix16Gifts = "0";
      goToNextStep();
    };

    // ---------- Picker ----------
    const parse = (swatch, key) => JSON.parse(swatch.dataset[key]);

    const updateAddButton = () => {
      addButton.disabled = !state.swatch || !state.size;
    };

    const selectSize = (size) => {
      state.size = size;
      setText("[data-c-mix16-picker-size]", size);
      sizesWrap.querySelectorAll("button").forEach((btn) => {
        btn.setAttribute("aria-pressed", String(btn.dataset.size === size));
      });
      updateAddButton();
    };

    // Stock check: "max" is the units left for tracked variants that can't oversell (null = no limit).
    // Pairs already in other slots count against it; in Same pack one pick fills every slot.
    const canPick = (variant) => {
      if (!variant.available) return false;
      if (variant.max === null || variant.max === undefined) return true;
      const same = build.dataset.cMix16Mode === "same";
      const used = same
        ? 0
        : state.pairs.filter((pair, index) => pair && index !== state.slot && pair.variantId === variant.id).length;
      const need = same ? state.pairs.length : 1;
      return variant.max - used >= need;
    };

    const selectSwatch = (swatch, preferredSize = "") => {
      state.swatch = swatch;
      swatches.forEach((el) => el.setAttribute("aria-pressed", String(el === swatch)));
      setText("[data-c-mix16-picker-name]", swatch.dataset.cMix16Title);
      setText("[data-c-mix16-picker-color]", swatch.dataset.cMix16Color);

      const images = parse(swatch, "cMix16Images");
      setText("[data-c-mix16-picker-photos]", images.length);
      gallery.innerHTML = "";
      images.forEach((src) => {
        const img = document.createElement("img");
        img.className = "c-v-pro-mix-16-picker__image";
        img.src = src;
        img.alt = swatch.dataset.cMix16Title;
        img.width = 348;
        img.height = 435;
        gallery.append(img);
      });
      gallery.scrollLeft = 0;

      const variants = parse(swatch, "cMix16Variants");
      sizesWrap.innerHTML = "";
      variants.forEach((variant) => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "c-v-pro-mix-16-picker__size";
        btn.dataset.size = variant.size;
        btn.textContent = variant.size;
        btn.disabled = !canPick(variant);
        sizesWrap.append(btn);
      });

      // No size until the shopper picks one; editing a pair keeps its size if still possible
      const preferred = variants.find((variant) => variant.size === preferredSize && canPick(variant));
      selectSize(preferred?.size || "");
    };

    // ---------- Collections (Var B) ----------
    const isVarB = () => document.body.classList.contains("c-vProMix16VarB");
    const moreButton = $("[data-c-mix16-more]");
    const wide = window.matchMedia("(min-width: 768px)");

    // Only the active collection's swatches; collapsed to 8 (mobile) / 12 (desktop) until "More"
    const renderSwatches = () => {
      const visible = swatches.filter((el) => el.dataset.cMix16Col === state.filter);
      const limit = picker.classList.contains("is-expanded") ? Infinity : wide.matches ? 12 : 8;

      swatches.forEach((el) => el.classList.add("is-off"));
      visible.forEach((el, index) => el.classList.toggle("is-off", index >= limit));
      moreButton.hidden = visible.length <= limit;
      setText("[data-c-mix16-colors-count]", `${visible.length} colors`);
    };

    const setFilter = (col) => {
      state.filter = isVarB() ? col : "marathon";
      $$("[data-c-mix16-filter]").forEach((btn) => btn.setAttribute("aria-pressed", String(btn.dataset.cMix16Filter === state.filter)));
      renderSwatches();
    };

    const openPicker = (index) => {
      const pair = state.pairs[index];
      const current = builder.dataset.cMix16Current;
      const pool = isVarB() ? swatches : swatches.filter((el) => el.dataset.cMix16Col === "marathon");

      state.slot = index;
      setText("[data-c-mix16-picker-pair]", index + 1);
      picker.classList.remove("is-expanded");

      // Editing a filled slot reopens on its colour + size; an empty slot opens with nothing selected,
      // on the collection of the product page the shopper is on
      const editing = pair && pool.find((el) => el.dataset.cMix16ProductId === String(pair.productId) && el.dataset.cMix16Col === pair.col);
      if (editing) {
        setFilter(editing.dataset.cMix16Col);
        selectSwatch(editing, pair.size);
      } else {
        // New pair: colour starts on this product page's style (or the collection's first); size is left for the shopper
        const start = pool.find((el) => el.dataset.cMix16ProductId === current) || pool[0];
        setFilter(start.dataset.cMix16Col);
        selectSwatch(start);
      }

      picker.showModal();
      document.documentElement.classList.add("c-v-pro-mix-16-locked");
    };

    const addPair = () => {
      const swatch = state.swatch;
      const variant = parse(swatch, "cMix16Variants").find((item) => item.size === state.size);
      const pair = {
        variantId: variant.id,
        productId: swatch.dataset.cMix16ProductId,
        color: swatch.dataset.cMix16Color,
        size: state.size,
        image: swatch.querySelector("img")?.src || "",
        price: variant.price,
        col: swatch.dataset.cMix16Col,
      };

      // Same pack: one style + size fills every slot
      if (build.dataset.cMix16Mode === "same") {
        state.pairs = state.pairs.map(() => ({ ...pair }));
      } else {
        state.pairs[state.slot] = pair;
      }

      renderSlots();
      picker.close();
      checkDone();
      goToNextStep();
    };

    const scrollGallery = (direction) => {
      const image = gallery.querySelector("img");
      if (image) gallery.scrollBy({ left: direction * (image.offsetWidth + 8), behavior: "smooth" });
    };


    // Size guide stacks over whichever picker is open
    const openGuide = (key) => {
      // Pair picker's guide = chart of the selected style's collection (Marathon / Wide Calf / Everyday)
      if (key === "socks") key = `col-${state.swatch?.dataset.cMix16Col || state.filter || "marathon"}`;
      guide.querySelectorAll("[data-c-mix16-guide-content]").forEach((el) => {
        el.hidden = el.dataset.cMix16GuideContent !== key;
      });
      guide.showModal();
      document.documentElement.classList.add("c-v-pro-mix-16-locked");
    };

    [picker, giftPicker, guide].forEach((dialog) => {
      // Keep the page locked while another modal is still open underneath
      dialog.addEventListener("close", () => {
        if (!builder.querySelector("dialog[open]")) {
          document.documentElement.classList.remove("c-v-pro-mix-16-locked");
        }
      });

      // Clicking the backdrop (the dialog itself, outside its inner panel) closes it
      dialog.addEventListener("click", (event) => {
        if (event.target === dialog) dialog.close();
      });
    });

    builder.addEventListener("click", (event) => {
      const target = event.target;

      const guideOpen = target.closest("[data-c-mix16-guide-open]");
      if (guideOpen) return openGuide(guideOpen.dataset.cMix16GuideOpen);
      if (target.closest("[data-c-mix16-guide-close]")) return guide.close();

      const pack = target.closest("[data-c-mix16-pack]");
      if (pack) return selectPack(pack);

      if (target.closest("[data-c-mix16-change]")) return changePack();

      // Review "Change" links reopen the build (and gift picks) for editing
      if (target.closest("[data-c-mix16-edit-build]")) {
        setReview(false);
        return scrollToEl(build);
      }
      if (target.closest("[data-c-mix16-edit-gifts]")) {
        setReview(false);
        builder.dataset.cMix16PicksOpen = "true";
        return scrollToEl($(".c-v-pro-mix-16-gifts"));
      }

      const modeBtn = target.closest("[data-c-mix16-mode-btn]");
      if (modeBtn) {
        if (modeBtn.dataset.cMix16ModeBtn === build.dataset.cMix16Mode) return;
        setMode(modeBtn.dataset.cMix16ModeBtn);
        state.pairs = state.pairs.map(() => null);
        return renderSlots();
      }

      const slot = target.closest("[data-c-mix16-slot]");
      if (slot && target.closest("[data-c-mix16-slot-remove]")) {
        state.pairs[slots.indexOf(slot)] = null;
        return renderSlots();
      }
      if (slot && target.closest("[data-c-mix16-slot-open]")) return openPicker(slots.indexOf(slot));
      if (target.closest("[data-c-mix16-same-open]")) return openPicker(0);

      if (target.closest("[data-c-mix16-gifts-open]")) {
        builder.dataset.cMix16PicksOpen = "true";
        return goToNextStep();
      }

      const giftCta = target.closest("[data-c-mix16-gift-cta]");
      if (giftCta) return toggleGift(giftCta.closest("[data-c-mix16-gift]"));

      const giftSize = target.closest("[data-c-mix16-gift-sizes] button");
      if (giftSize) return selectGiftSize(giftSize.dataset.size);

      if (target.closest("[data-c-mix16-gift-add]")) return addGift();
      if (target.closest("[data-c-mix16-gift-close]")) return giftPicker.close();

      const atc = target.closest("[data-c-mix16-atc]");
      if (atc) return addBundle(atc);

      const swatch = target.closest("[data-c-mix16-swatch]");
      if (swatch) return selectSwatch(swatch);

      const size = target.closest(".c-v-pro-mix-16-picker__size");
      if (size) return selectSize(size.dataset.size);

      if (target.closest("[data-c-mix16-more]")) {
        picker.classList.add("is-expanded");
        return renderSwatches();
      }

      const filterBtn = target.closest("[data-c-mix16-filter]");
      if (filterBtn) {
        picker.classList.remove("is-expanded");
        setFilter(filterBtn.dataset.cMix16Filter);
        // Keep the current style if it's in this collection, otherwise jump to the collection's first
        // Switching collection starts on its first style; size is picked again
        if (state.swatch?.dataset.cMix16Col !== state.filter) {
          const first = swatches.find((el) => el.dataset.cMix16Col === state.filter);
          if (first) selectSwatch(first);
        }
        return;
      }
      if (target.closest("[data-c-mix16-add]")) return addPair();
      if (target.closest("[data-c-mix16-picker-close]")) return picker.close();
      if (target.closest("[data-c-mix16-gallery-prev]")) return scrollGallery(-1);
      if (target.closest("[data-c-mix16-gallery-next]")) return scrollGallery(1);
    });
  };

  const run = () => document.querySelectorAll("[data-c-mix16-builder]").forEach(init);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
